
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Replace with your Firebase web config (Console → Project settings → Web)
// This object is safe to expose in a web app.
const firebaseConfig = {
  apiKey: "AIzaSyDx6RQeIUB2sEPhnJr_QO7klwW4phgGfGc",
  authDomain: "admin-6d04e.firebaseapp.com",
  projectId: "admin-6d04e",
  storageBucket: "admin-6d04e.firebasestorage.app",
  messagingSenderId: "291701122795",
  appId: "1:291701122795:web:4310e06b994941234200ae",
  measurementId: "G-P23Q4F6JZN"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
